
export default function Footer() {
  return (
    <footer className="uk-flex uk-flex-center uk-flex-middle">
      <div className="uk-width-3-4">
        <div className="uk-text-right uk-text-white">COPYRIGHT © DRM ALL RIGHTS RESERVED.</div>
      </div>
    </footer>
  );
}